const MessageIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="21"
      height="21"
      viewBox="0 0 21 21"
      fill="none"
    >
      <g clipPath="url(#clip0_1680_20169)">
        <path
          d="M8.36719 8.86758C8.36719 9.31041 8.5431 9.7351 8.85623 10.0482C9.16936 10.3614 9.59406 10.5373 10.0369 10.5373C10.4797 10.5373 10.9044 10.3614 11.2175 10.0482C11.5307 9.7351 11.7066 9.31041 11.7066 8.86758C11.7066 8.42474 11.5307 8.00005 11.2175 7.68692C10.9044 7.37379 10.4797 7.19788 10.0369 7.19788C9.59406 7.19788 9.16936 7.37379 8.85623 7.68692C8.5431 8.00005 8.36719 8.42474 8.36719 8.86758Z"
          stroke="currentColor"
          strokeWidth="1.6697"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12.5667 13.4404C11.7556 13.7331 10.8993 13.8806 10.0371 13.8762C7.03163 13.8762 4.52708 12.2065 2.52344 8.86713C4.52708 5.52773 7.03163 3.85803 10.0371 3.85803C13.0425 3.85803 15.5471 5.52773 17.5507 8.86713C17.4803 8.98459 17.4085 9.1012 17.3353 9.21693"
          stroke="currentColor"
          strokeWidth="1.6697"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M15.8809 12.2065V14.7111"
          stroke="currentColor"
          strokeWidth="1.6697"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M15.8809 17.2156V17.2244"
          stroke="currentColor"
          strokeWidth="1.6697"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_1680_20169">
          <rect
            width="20.0364"
            height="20.0364"
            fill="white"
            transform="translate(0.0185547 0.518188)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default MessageIcon;
